import { Instance, types } from 'mobx-state-tree';

const AccountInfo = types.model({
  businessName: '',
  clabe: '',
  bankName: '',
});

export interface AccountInfoStore extends Instance<typeof AccountInfo> {}
export default AccountInfo;
